import './Notifications.css';
import React, { useEffect } from 'react';
import { useData } from '../../model/data';
import { NotificationMessage } from './NotificationMessage';
import { history } from '../../model/history';
import { reloadNotificationFunctions } from '../../model/store';

export function Notifications(): JSX.Element | null {
  const notifications = useData((db) => db.table('notifications').all);
  useEffect(() => {
    const locationUrl = new URL(location.toString());
    const notificationKey = locationUrl.searchParams.get('reloadNotification');
    if (!notificationKey) return;

    reloadNotificationFunctions[notificationKey]?.();
    locationUrl.searchParams.delete('reloadNotification');
    history.replace(locationUrl);
  });

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notifications">
      {notifications.map((notification) => (
        <NotificationMessage key={notification.id} notification={notification} />
      ))}
    </div>
  );
}
